module.exports = __webpack_public_path__ + "media/images/menu/csm_france-fc44cb0ae801b5b01ab93ea9f3e20350.png";